/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/.lodash@4.17.4@lodash/_freeGlobal.js
// module id = 82
// module chunks = 0